<script>
/* eslint-disable */

import { mapGetters } from "vuex";
import Multiselect from "@vueform/multiselect/dist/multiselect.vue2.js";

import InlineFileUpload from "../uploads/InlineFileUpload.vue";

export default {
  components: {
    Multiselect,
    InlineFileUpload,
  },
  data() {
    return {
      categories: [],
      editImage: false,
    };
  },
  methods: {
    editImageFunc() {
      this.editImage = true;
    },
    handleFileUploaded(file) {
      this.image = file;
    },
    hideUploadModal() {},
    closeModal() {
      this.$store.commit("recipes/setShowIngredientsModal", false);
      this.editImage = false;
    },

    createUpdate(ingredient) {
      if (this.ingredientStatus == "create") {
        this.$store
          .dispatch("recipes/createIngredientGroupItem", ingredient)
          .then((id) => {
            this.ingredientId = id;
            this.ingredientStatus = "added";
            this.$store.commit(`commons/setSavingForm`, "Saved");
          });
      } else {
        ingredient.id = this.ingredientId;
        this.$store
          .dispatch("recipes/updateIngredientGroupItem", ingredient)
          .then((res) => {
            this.$store.commit(`commons/setSavingForm`, "Saved");
          });
      }
    },
    async createIngredient() {
      this.$store
        .dispatch("recipes/createIngredient", this.currentIngredient)
        .then((res) => {
          var ingredient = this.currentIngredientMode.ingredient;
          var newIngredient = {
            id: ingredient.id,
            ingredient_group: ingredient.ingredient_group,
            position: ingredient.position,
            amount: ingredient.amount,
            note: ingredient.note,
            ingredient: res.id,
            unit: this.unit_name,
          };

          if (this.currentIngredientMode.status == "create") {
            this.$store
              .dispatch(
                "recipes/createIngredientGroupItemOnModal",
                newIngredient
              )
              .then((data) => {
                console.log(data, "result createIngredientGroupItemOnModal");
                this.$store.commit(`commons/setSavingForm`, "Saved");
              });
          } else {
            this.$store
              .dispatch(
                "recipes/updateIngredientGroupItemOnModal",
                newIngredient
              )
              .then((res) => {
                this.$store.commit(`commons/setSavingForm`, "Saved");
              });
          }
        });

      this.closeModal();
    },
    async updateIngredient() {
      this.$store
        .dispatch("recipes/updateIngredient", this.currentIngredient)
        .then((res) => {
          console.log(res);
        });
      this.closeModal();
    },
  },

  computed: {
    ...mapGetters({
      showIngredientsModal: "recipes/showIngredientsModal",
      units: "recipes/units",
      categoriesOptions: "recipes/categoriesOptions",
      currentIngredient: "recipes/currentIngredient",
      currentIngredientMode: "recipes/currentIngredientMode",
      ingredients: "recipes/ingredients",
    }),
    name: {
      set(value) {
        this.$store.commit(`recipes/currentIngredientField`, {
          fieldName: "name",
          value,
        });
      },
      get() {
        if (this.currentIngredient) {
          return this.currentIngredient.name;
        }
        return "";
      },
    },
    unit: {
      set(value) {
        this.$store.commit(`recipes/currentIngredientField`, {
          fieldName: "unit",
          value,
        });
      },
      get() {
        if (this.currentIngredient) {
          return this.currentIngredient.unit;
        }
        return "";
      },
    },
    image: {
      set(value) {
        this.$store.commit(`recipes/currentIngredientField`, {
          fieldName: "image",
          value,
        });
      },
      get() {
        if (this.currentIngredient) {
          return this.currentIngredient.image;
        }
        return "";
      },
    },
    unit_name: {
      set(value) {
        this.$store.commit(`recipes/currentIngredientField`, {
          fieldName: "unit_name",
          value,
        });
      },
      get() {
        if (this.currentIngredient) {
          return this.currentIngredient.unit_name;
        }
        return "";
      },
    },

    modalState: {
      set(value) {
        this.$store.commit("recipes/setShowIngredientsModal", value);
      },
      get() {
        return this.showIngredientsModal;
      },
    },
  },

  watch: {
    unit(newUnit) {
      const unit = this.units.find((unit) => unit.value == newUnit);
      this.unit_name = unit.text;
    },
  },
};
</script>

<style scoped>
.controls {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 10px;
}
.controls button {
  text-transform: uppercase;
}
.form div {
  margin-bottom: 1rem;
}
</style>

<template>
  <b-modal hide-footer v-model="modalState">
    <template #modal-title>
      <div class="text-uppercase">
        {{ currentIngredientMode.status }} ingredient
      </div>
    </template>
    <div class="form">
      <div>
        <label for="range-1">Ingredient Name</label>
        <b-form-input id="name" v-model="name" />
      </div>
      <div>
        <label for="range-unit">Unit</label>
        <b-form-select
          v-model="unit"
          :options="units"
          size="sm"
        ></b-form-select>
      </div>
      <div>
        <label for="range-upload-image">Upload Image</label>
        <inline-file-upload
          :allowMultipleUploads="false"
          v-on:file-uploaded="handleFileUploaded"
          v-on:file-upload-closed="hideUploadModal"
          v-if="!image || editImage"
        >
        </inline-file-upload>

        <div
          v-if="image && !editImage"
          class="mt-1 portrait image-wrapper img-fluid"
          :style="{
            backgroundImage: 'url(\'' + image + '\')',
          }"
        >
          <button @click="editImageFunc()" class="edit">
            <b-icon icon="pencil" />
          </button>
        </div>
      </div>
      <div class="controls">
        <b-button @click="closeModal">Cancel</b-button>
        <b-button
          variant="primary"
          @click="createIngredient"
          v-if="currentIngredientMode.status == 'create'"
          >{{ currentIngredientMode.status }} Ingredient</b-button
        >
        <b-button
          variant="primary"
          @click="updateIngredient"
          v-if="currentIngredientMode.status == 'update'"
          >{{ currentIngredientMode.status }} Ingredient</b-button
        >
      </div>
    </div>
  </b-modal>
</template>
